import PlayerHistory from './PlayerHistory';
export default PlayerHistory;
